/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MoneyInSofortInitOutput
 */
export interface MoneyInSofortInitOutput {
    /**
     * Transaction ID. You will this this value to confirm the transaction
     * @type {number}
     * @memberof MoneyInSofortInitOutput
     */
    id?: number;
    /**
     * Redirected URL for the client on the iDeal page payment
     * @type {string}
     * @memberof MoneyInSofortInitOutput
     */
    actionUrl?: string;
    /**
     * 
     * @type {Error}
     * @memberof MoneyInSofortInitOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the MoneyInSofortInitOutput interface.
 */
export function instanceOfMoneyInSofortInitOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MoneyInSofortInitOutputFromJSON(json: any): MoneyInSofortInitOutput {
    return MoneyInSofortInitOutputFromJSONTyped(json, false);
}

export function MoneyInSofortInitOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyInSofortInitOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'actionUrl': !exists(json, 'actionUrl') ? undefined : json['actionUrl'],
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function MoneyInSofortInitOutputToJSON(value?: MoneyInSofortInitOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'actionUrl': value.actionUrl,
        'error': value.error,
    };
}

